import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=2a122d93"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=2a122d93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports